module.exports = __webpack_public_path__ + "img/face-smile-wink.72c73565.svg";